import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public employee(empoyeeId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/feedback`, { params: new HttpParams({ fromObject: { employee: empoyeeId } }) });
  }

  public assignment(assignmentId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/feedback`, { params: new HttpParams({ fromObject: { assignment: assignmentId } }) });
  }

  public location(locale: string): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/feedback`, { params: new HttpParams({ fromObject: { locale: locale } }) });
  }

  public save(data: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/feedback`, data);
  }
}
